export default __webpack_public_path__ + "static/media/Shah-Jahan-Mumtaz-in-Burhanpur.32afcf8f.jpg";